import { identity } from "@/data/portfolio";
import { handleResume } from "@/components/Nav";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 px-6 py-12 md:px-12 lg:px-20">
    <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="font-mono text-sm font-bold tracking-widest text-white">
          KS<span className="text-cyan-400">//</span>SAHU
        </p>
        <p className="mt-3 max-w-md font-mono text-xs leading-relaxed text-zinc-600">
          {identity.role} · {identity.location}. Career data synced with
          LinkedIn; repositories synced with public GitHub profile.
        </p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-3 font-mono text-xs uppercase tracking-[0.2em]">
        <a href="/ai-engineering" onClick={(e) => { e.preventDefault(); window.location.href = "/ai-engineering"; }} data-testid="footer-ai-engineering-link" className="text-zinc-500 transition-colors duration-300 hover:text-cyan-400">AI Engineering</a>
        <a href={identity.links.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="text-zinc-500 transition-colors duration-300 hover:text-cyan-400">LinkedIn</a>
        <a href={identity.links.github} target="_blank" rel="noopener noreferrer" data-testid="footer-github-link" className="text-zinc-500 transition-colors duration-300 hover:text-cyan-400">GitHub</a>
        <a href={identity.links.prefilter} target="_blank" rel="noopener noreferrer" data-testid="footer-prefiler-link" className="text-zinc-500 transition-colors duration-300 hover:text-cyan-400">Prefiler</a>
        <a href="/resume.pdf" onClick={handleResume} data-testid="footer-resume-link" className="text-zinc-500 transition-colors duration-300 hover:text-cyan-400">Resume</a>
      </div>
    </div>
    <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-700">
      © 2026 Karan Sahu — Built with React, Framer Motion & Lenis
    </p>
  </footer>
);
